/**
 * AIIA Brand Logo Components
 * AIIA ბრენდის ლოგოს კომპონენტები
 */

/** Logo icon — AI mark only */
export function LogoIcon({ size = 32, className = '' }: { size?: number; className?: string }) {
  return (
    <img
      src="/logo.png"
      alt="AIIA"
      width={size}
      height={size}
      className={`object-contain ${className}`}
    />
  );
}

/** Full logo — icon + "AIIA" text */
export function LogoFull({ iconSize = 32, className = '' }: { iconSize?: number; className?: string }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <LogoIcon size={iconSize} />
      <div className="flex flex-col leading-tight">
        <span className="font-bold text-gray-900 tracking-tight" style={{ fontSize: iconSize * 0.55 }}>
          AIIA
        </span>
        <span className="text-gray-400 font-medium" style={{ fontSize: iconSize * 0.3 }}>
          აი-ია
        </span>
      </div>
    </div>
  );
}

/** Full logo with white text (for dark backgrounds) */
export function LogoFullWhite({ iconSize = 32, className = '' }: { iconSize?: number; className?: string }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <LogoIcon size={iconSize} />
      <div className="flex flex-col leading-tight">
        <span className="font-bold text-white tracking-tight" style={{ fontSize: iconSize * 0.55 }}>
          AIIA
        </span>
        <span className="text-gray-300 font-medium" style={{ fontSize: iconSize * 0.3 }}>
          აი-ია
        </span>
      </div>
    </div>
  );
}
